import React from 'react';
import EcoTabSectionLR from 'eco-design/sections/eco-tab-section-l-r';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const IndustryLeadingF: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingF');

    const descDataItems = [
        {
            title: t.rich('item1_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item1_desc'),
            tips: t('item1_tips'),
        },
        {
            title: t.rich('item2_title', {
                text1: (text: string) => <span>{text}</span>,
            }),
            desc: t('item2_desc'),
            tips: t('item2_tips'),
        },
    ];

    const getContentDesc = (index: number) => {
        const itemData = descDataItems[index];
        return (
            <div className="right-item">
                <div className={`item-title item-${index}-title`}>{itemData.title}</div>
                <div className="item-desc">{itemData.desc}</div>
                <div className="item-tips">{itemData.tips}</div>
            </div>
        );
    };

    return (
        <section className={`${styles.IndustryLeadingF} GtmModuleData-section`} id="IndustryLeadingF" data-section-id={'IndustryLeadingF'}>
            <div className="industry-bg-wrap">
                <div className="title-box">
                    <h4 className="title">{t('title')}</h4>
                    <p className="desc">{t('desc')}</p>
                </div>
                <EcoTabSectionLR
                    className="section-card-faq"
                    items={[
                        {
                            title: '',
                            desc: getContentDesc(0),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1757042057192/industry-f-1-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757042057192/industry-f-1-pc.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757499913447/Frame%201000008992-1-m.jpg',
                            tabLabel: 'ポートを前面に集約',
                            tabValue: 'a',
                        },
                        {
                            title: '',
                            desc: getContentDesc(1),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1757492684104/industry-f-2-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1757492684104/industry-f-2-pc.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757499928887/Frame%202094654274-2-m.jpg',
                            tabLabel: 'コンパクト設計',
                            tabValue: 'b',
                        },
                    ]}
                />
            </div>
        </section>
    );
};

export default IndustryLeadingF;
